/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import formatCurrency from 'lib/format-currency';
import { createSelector } from 'reselect';
import colors from 'theme/charts/colors';
import translations from 'translations';
import configSelector from './config';

const selectTopBusiness = createSelector(
  (state) => state.aggr.payload,
  (_, key) => key,
  configSelector,
  (payload, key, config) => {
    const { languageCode } = config;

    const pieChartData = [
      {
        label: translations[languageCode].retail,
        key: 'buy',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[0],
      },
      {
        label: translations[languageCode].subscription,
        key: 'subscription',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[1],
      },
      {
        label: translations[languageCode].libraries,
        key: 'rent',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[2],
      },
      {
        label: translations[languageCode].refund,
        key: 'refund',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[3],
      },
      {
        label: translations[languageCode].free_download,
        key: 'free_download',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[4],
      },
      {
        label: translations[languageCode].repartition_charge,
        key: 'repartition_charge',
        growthRates: null,
        percent: 0,
        value: null,
        color: colors.business_revenues[5],
      },
    ];

    let currentTotal = 0;
    let previousTotal = 0;

    const result = {
      pieChartData,
      value: null,
      percent: null,
      isWaiting: true,
    };

    if (!payload[key] || !payload[key].data) return result;

    const {
      isWaiting,
      currency,
      data: {
        aggregations: {
          results: { buckets },
        },
      },
    } = payload[key];

    // ADD percent ( diff with prev period ) and value
    result.pieChartData = result.pieChartData.filter((asset) => {
      const bucket = buckets.find(({ key: k }) => {
        k = k ? k.toLowerCase() : k;
        return asset.key === k;
      });

      if (!bucket) return false;

      return true;
    });

    result.pieChartData = result.pieChartData.map((asset) => {
      const bucket = buckets.find(({ key: k }) => {
        k = k ? k.toLowerCase() : k;
        return asset.key === k;
      });

      if (!bucket)
        return {
          ...asset,
          growthRates: 0,
          currentValue: 0,
          value: currency === 'eur' ? '0,00 €' : '$0.00',
        };

      const {
        current_period: {
          total_revenues: { value: currentValue },
        },
        previous_period: {
          total_revenues: { value: previousValue },
        },
      } = bucket;

      currentTotal += currentValue;
      previousTotal += previousValue;

      let growthRates = 0;

      if (previousValue !== 0) {
        growthRates = Math.round(((currentValue - previousValue) / previousValue) * 100);
      }

      const value = formatCurrency(currency, currentValue);

      return {
        ...asset,
        growthRates,
        value,
        currentValue,
      };
    });

    // ADD percentPie ( percent of the pie chart )
    result.pieChartData = result.pieChartData.map((asset) => {
      const bucket = buckets.find(({ key: k }) => {
        k = k ? k.toLowerCase() : k;
        return asset.key === k;
      });

      if (!bucket) return asset;

      const {
        current_period: {
          total_revenues: { value: currentValue },
        },
      } = bucket;

      let percent = 0;

      if (currentTotal !== 0) {
        percent = Math.round(currentValue / (currentTotal / 100));
      }

      return {
        ...asset,
        percent,
      };
    });

    // Sort by currentValue
    result.pieChartData.sort((a, b) => a.currentValue - b.currentValue).reverse();

    result.value = formatCurrency(currency, currentTotal);

    if (previousTotal !== 0) {
      result.percent = Math.round(((currentTotal - previousTotal) / previousTotal) * 100);
    } else {
      result.percent = 0;
    }

    return { ...result, isWaiting };
  },
);

export default selectTopBusiness;
